import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { IoClose } from 'react-icons/io5';
import { Box } from '@mui/material';
export default function ReajectReason(props) {
  return (
    <Dialog
      open={props?.open}
      PaperProps={{
        component: 'form',
        onSubmit: (e) => {
          e.preventDefault();
          props?.handleReject;
        }
      }}
    >
      <DialogContent>
        <DialogContentText sx={{ width: '30vw' }}>Remarks</DialogContentText>
        <Box sx={{ cursor: 'pointer', fontSize: '25px', position: 'absolute', top: 8, right: 8 }} onClick={() => props?.handleClose()}>
          <IoClose />
        </Box>
        <TextField
          autoFocus
          required
          margin="dense"
          id="name"
          name="reason"
          type="text"
          fullWidth
          variant="standard"
          onChange={(e) => props?.setRejectReason(e.target.value)}
        />
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          variant="contained"
          color="secondary"
          onClick={
            sessionStorage.getItem('UserType') === 'gm'
              ? props?.handleGmApprove
              : sessionStorage.getItem('UserType') === 'prod_own'
              ? props.handleProdOwnerApprove
              : sessionStorage.getItem('UserType') === 'non_fi_head'
              ? props.handleNonFiHeadApprove
              : props.handleReject
          }
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
